import CryptoJS from "crypto-js";

export function encryptData(text) {
  var KEY = "12345678909805668314220304050607";
  var IV = "1234567890980563"; //16 bits
  var key = CryptoJS.enc.Utf8.parse(KEY);
  var iv = CryptoJS.enc.Utf8.parse(IV);

  var encrypted = "";

  var srcs = CryptoJS.enc.Utf8.parse(text);
  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.ciphertext.toString();
}
export const decryptDataInviteLink = (cipherText) => {
   var secretKey = "12345678900000001234567890000000"; //32 bit
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};


export function decryptData(text) {
  var KEY = "12345678909805668314220304050607"; //32 bit
  var IV = "1234567890980563"; //16 bits
  var key = CryptoJS.enc.Utf8.parse(KEY);
  var iv = CryptoJS.enc.Utf8.parse(IV);

  var decrypted = "";

  var srcs = CryptoJS.enc.Utf8.parse(text);
  decrypted = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.ciphertext.toString();
}
export function decryptDataPublicLogin(hexText) {
  const KEY = "12345678909805668314220304050607";
  const IV = "1234567890980563"; // 16 bytes
  const key = CryptoJS.enc.Utf8.parse(KEY);
  const iv = CryptoJS.enc.Utf8.parse(IV);

  try {
    const encryptedHex = CryptoJS.enc.Hex.parse(hexText);
    const encryptedBase64 = CryptoJS.enc.Base64.stringify(encryptedHex); // convert to Base64

    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error("Decryption error:", err);
    return null;
  }
}

// Method for base64 decrypt

export function base64DecryptData(str) {
  if (str !== undefined && str !== null) {
    // Replace any spaces with '+' (if necessary)
    str = str.replace(/\s/g, "+");

    // Decode from Base64
    const decodedBytes = atob(str); // 'atob' decodes from Base64

    // Convert byte array (decoded string) to a UTF-8 string
    const decodedString = decodeURIComponent(escape(decodedBytes));

    return decodedString;
  }
}
